var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1C4C5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2496 10.5496C13.2496 11.4846 12.6546 12.2496 11.5496 12.2496C10.5296 12.2496 9.84961 11.4846 9.84961 10.6346C9.84961 9.69961 10.5296 8.84961 11.5496 8.84961C12.5696 8.84961 13.2496 9.61461 13.2496 10.5496ZM9.84961 24.1496H13.2496V13.0996H9.84961V24.1496ZM21.4096 13.2696C19.6246 13.2696 18.6046 14.2896 18.1796 14.9696H18.0946L17.9246 13.5246H14.8646C14.8646 14.4596 14.9496 15.5646 14.9496 16.8396V24.1496H18.3496V18.1146C18.3496 17.7746 18.3496 17.5196 18.4346 17.2646C18.6896 16.6696 19.1146 15.9046 20.0496 15.9046C21.2396 15.9046 21.7496 16.9246 21.7496 18.2846V24.1496H25.1496V17.8596C25.1496 14.7146 23.5346 13.2696 21.4096 13.2696Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.f83c1cd0.svg";
export { ForwardRef as ReactComponent };